import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
  children?: React.ReactNode;
}

export const FltRecCategoryItem = styled.li<IProps>`
  .btn {
    width: 100%;
    ${mixin.flex({ justify: 'flex-start' })};
    white-space: nowrap;
  }

  .tag {
    font-size: 11px;
    margin-right: 6px;
  }

  .text:not(.cnt) {
    font-size: 13px;
    line-height: 130%;
    color: #555;
    text-align: left;

    em {
      ${mixin.flex({ display: 'inline-flex' })};
      margin: 0 2px;
      width: 12px;
      height: 12px;

      svg {
        width: 7px;
        height: 10px;
      }
    }
  }

  .cnt {
    font-size: 12px;
    margin-left: 4px;
    color: #bbb;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .tag {
      margin-right: ${mixin.pxToVw('6')};
    }

    .text:not(.cnt) {
      font-size: ${mixin.pxToVw('13')};

      em {
        margin: ${mixin.pxToVw('0 2')};
        width: ${mixin.pxToVw('12')};
        height: ${mixin.pxToVw('12')};

        svg {
          width: ${mixin.pxToVw('7')};
          height: ${mixin.pxToVw('10')};
        }
      }
    }

    .cnt {
      font-size: ${mixin.pxToVw('12')};
      margin-left: ${mixin.pxToVw('4')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .text:not(.cnt) {
      font-size: 14px;

      em {
        margin: 0 2px;
        width: 14px;
        height: 14px;

        svg {
          width: 7px;
          height: 12px;
        }
      }
    }

    .cnt {
      font-size: 13px;
    }
  }
`;
